"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_PARSE_FORMATS_FNS = exports.TIME_PASTE_FORMATS_FNS = exports.TIME_PARSE_FORMATS = exports.TIME_PASTE_FORMATS = exports.TIME_FORMATS_MAPPING = void 0;
const moment_1 = __importDefault(require("moment"));
exports.TIME_FORMATS_MAPPING = {
    "12h": "h:mm a",
    "24h": "HH:mm",
};
exports.TIME_PASTE_FORMATS = [
    "H",
    "HA",
    "H A",
    "HH",
    "HHA",
    "HH A",
    "Hmm",
    "HmmA",
    "Hmm A",
    "HHmm",
    "HHmmA",
    "HHmm A",
    "HH:mm",
    "HH:mmA",
    "HH:mm A",
    "H.mm",
    "H.mmA",
    "H.mm A",
    "HH.mm",
    "HH.mmA",
    "HH.mm A",
    "H,mm",
    "H,mmA",
    "H,mm A",
    "HH,mm",
    "HH,mmA",
    "HH,mm A",
    "H mm",
    "H mmA",
    "H mm A",
    "HH mm",
    "HH mmA",
    "HH mm A",
    "h:mm A",
    "hh:mm A",
    "H:mm",
    "HH:mm:ss",
];
exports.TIME_PARSE_FORMATS = [...exports.TIME_PASTE_FORMATS, moment_1.default.ISO_8601];
exports.TIME_PASTE_FORMATS_FNS = [
    "H",
    "h a",
    "h a",
    "HH",
    "hh a",
    "hh a",
    "Hmm",
    "hmm a",
    "hmm a",
    "HHmm",
    "hhmm a",
    "hhmm a",
    "HH:mm",
    "hh:mm a",
    "hh:mm a",
    "H.mm",
    "h.mm a",
    "h.mm a",
    "HH.mm",
    "hh.mm a",
    "hh.mm a",
    "H,mm",
    "h,mm a",
    "h,mm a",
    "HH,mm",
    "hh,mm a",
    "hh,mm a",
    "H mm",
    "h mm a",
    "h mm a",
    "HH mm",
    "hh mm a",
    "hh mm a",
    "H:mm",
    "HH:mm:ss",
];
exports.TIME_PARSE_FORMATS_FNS = exports.TIME_PASTE_FORMATS_FNS;
